module.exports = __webpack_public_path__ + "static/media/plates.1d258e32.jpg";